"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import IImportationDetails from "@/interfaces/importation-details";
import { ImportationDetailsMessages } from "@/messages/importationDetails/importation-details.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ImportationDetailsTableRow } from "./row";
import { TABLE_COLUMNS } from "../../constants";

interface Props {
  data: PaginatedResponse<IImportationDetails>;
  pagination: Pagination;
  messages: ImportationDetailsMessages;
}

export function ImportationDetailsTable({ data, pagination, messages }: Props) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items &&
              data.items.map((importDetail, index) => (
                <ImportationDetailsTableRow
                  key={`${index} - ${importDetail.id}`}
                  importation={importDetail}
                  index={index}
                  messages={messages}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
